export default "__VITE_ASSET__CCNEaxq5__"